module.exports = __webpack_public_path__ + "img/m2-screenshot-09.16774ccb.png";